import type { T_Maybe, T_Record } from '@tryiris-ai/js-types';

/** @internal */
export const Hints: T_Record<T_Maybe<string>> = Object.freeze({
  "'": 'Single quote',
  ',': 'Comma',
  '.': 'Period',
  '/': 'Forward Slash',
  ';': 'Semicolon',
  '=': 'Equals',
  '[': 'Left Bracket',
  '\\': 'Backslash',
  ']': 'Right Bracket',
  '`': 'Back Quote',
  '-': 'Minus Sign',
  'Alt': 'Alt/Option',
  'Ctrl': 'Control',
  '←': 'Left Arrow',
  '↑': 'Up Arrow',
  '→': 'Right Arrow',
  '↓': 'Down Arrow',
  '⇧': 'Shift',
  '⌃': 'Control',
  '⌘': 'Command',
  '⌥': 'Option/Alt'
});
